<template lang="pug">
.side-panel-container
  .dark-over-lay(:class="{'active' : !!selectedCollapseTab  }")
  .side-panel
    template(v-for="item in sidePanelItems" :key="item.key")
      aiq-tooltip(v-if="item?.shouldShow" effect="dark", :content="item.title", placement="left", :show-after="500")
        fa-icon(:icon="['fas', item.iconName]" @click="onTabClickChange(item.key)" :class="{'active' : selectedCollapseTab === item.key  }")

  .side-panel-wrapper(:class="{'is-active' : !!selectedCollapseTab  }")
    .header-conversation-info
      h3.title {{returnSidePanelItem(selectedCollapseTab).title}}
      fa-icon(:icon="['fas', 'xmark']" @click="onTabClickChange('')")
    .wrapper
      div(class="wrapper-children" v-if="selectedCollapseTab === sidePanelTabNames.AI_TESTING")
        .inline-intro
          ai-testing()
      div(class="wrapper-children" v-if="selectedCollapseTab === sidePanelTabNames.BUILDING_KIT && shouldRenderBuildingKit")
        .inline-intro
          building-kit(:show-header="false",
                    :tabs="buildingTabs")
</template>

<script>
import aiTesting from '@/components/AiTesting/AiTesting.vue';
import buildingKit from './BuildingKit/BuildingKit.vue';

import { defaultBuildingKitTabs } from '@/libs';
import { IQ_TOOL_BUILDING_KIT_TAB_NAMES } from '@/constants';

export default {
  name: 'buildingKitAiTesting',
  components: {
    buildingKit,
    aiTesting,
  },
  data() {
    return {
      buildingTabs: [],
      selectedCollapseTab: null,
      sidePanelTabNames: IQ_TOOL_BUILDING_KIT_TAB_NAMES,
      shouldRenderBuildingKit: false,
    };
  },
  computed: {
    sidePanelItems() {
      return [
        {
          key: 'AI_TESTING',
          title: this.$t('iq_tools_tab.side_panel.ai_testing.title'),
          shouldShow: true,
          iconName: 'brain-circuit',
        },
        {
          key: 'BUILDING_KIT',
          title: this.$t('iq_tools_tab.side_panel.building_kit.title'),
          shouldShow: true,
          iconName: 'gear-code',
        },
      ];
    },
  },
  mounted() {
    this.buildingTabs = defaultBuildingKitTabs.filter(e => e.key !== 'intent');
  },
  methods: {
    returnSidePanelItem(key) {
      const sidePanelItem = this.sidePanelItems.find(item => item.key === key);
      return sidePanelItem || {};
    },
    onTabClickChange(key) {
      this.selectedCollapseTab = key;
      this.shouldRenderBuildingKit = false;

      if (key === this.sidePanelTabNames.BUILDING_KIT) {
        this.$nextTick(() => {
          // Add a small delay to allow the side panel animation to complete
          setTimeout(() => {
            this.shouldRenderBuildingKit = true;
          }, 300); // eslint-disable-line no-magic-numbers
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inside-panel {
  width: 306.766px;
}
.side-panel-container {
  .side-panel-wrapper {
    .wrapper {
      height: calc(100vh - 120px);
      .wrapper-children {
        padding: 0;
        overflow-y:initial;
        height: auto;
      }
    }
  }
}

</style>
